import { render, staticRenderFns } from "./chemSafetyCommun.vue?vue&type=template&id=c1606610"
import script from "./chemSafetyCommun.vue?vue&type=script&lang=js"
export * from "./chemSafetyCommun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1606610')) {
      api.createRecord('c1606610', component.options)
    } else {
      api.reload('c1606610', component.options)
    }
    module.hot.accept("./chemSafetyCommun.vue?vue&type=template&id=c1606610", function () {
      api.rerender('c1606610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/eap/base/chemSafetyCommun.vue"
export default component.exports